const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const US_DATE_RE = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

export function normalizeDateOnly(value) {
  if (value == null || value === '') return null;

  const trimmed = String(value).trim();
  if (ISO_DATE_RE.test(trimmed)) return trimmed;

  const usMatch = trimmed.match(US_DATE_RE);
  if (!usMatch) return null;

  const [, month, day, year] = usMatch;
  const monthNumber = Number(month);
  const dayNumber = Number(day);
  const yearNumber = Number(year);
  if (!monthNumber || !dayNumber || !yearNumber) return null;

  const date = new Date(yearNumber, monthNumber - 1, dayNumber);
  if (
    date.getFullYear() !== yearNumber ||
    date.getMonth() !== monthNumber - 1 ||
    date.getDate() !== dayNumber
  ) {
    return null;
  }

  return `${yearNumber}-${String(monthNumber).padStart(2, '0')}-${String(dayNumber).padStart(2, '0')}`;
}

/** ISO (YYYY-MM-DD) or existing MM/DD/YYYY → DatePickerInput value */
export function formatDateOnlyForPicker(value) {
  if (value == null || value === '') return '';
  const trimmed = String(value).trim();
  if (US_DATE_RE.test(trimmed)) return trimmed;
  const iso = normalizeDateOnly(trimmed);
  if (!iso) return trimmed;
  const [year, month, day] = iso.split('-');
  return `${month}/${day}/${year}`;
}

export function getInvoiceDueDateFilterForApi(value) {
  return normalizeDateOnly(value) || '';
}
